module.exports = __webpack_public_path__ + "static/media/website.318f58f8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/moonsflow/website.svg
// module id = 646
// module chunks = 0